<ng-container>
  <h3 class="text-center" mat-dialog-title>Seems like there are duplicates, are you sure you want to override them?</h3>
  <div mat-dialog-content>
    <mat-table [dataSource]="data$.products">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>
          {{ "products.table.prdNameEn" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div>
            <span class="mobile-label"><strong>{{ "products.table.prdNameEn" | translate
                }}:</strong></span>

            <span>{{row.prdNameEn}}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="prdCode">
        <mat-header-cell *matHeaderCellDef class="flex-header">{{
          "products.table.prdCode" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-header">
          <span class="mobile-label"><strong>{{ "products.table.prdCode" | translate
              }}</strong></span>
          {{row.prdCode}}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns$; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns$;">
      </mat-row>
    </mat-table>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" class="pt-20 pb-20">
      <button mat-raised-button (click)="_matDialogRef.close()">{{ "cancel" | translate }}</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" cdkFocusInitial [mat-dialog-close]="true">{{ "confirm" | translate }}
        <span *ngIf="data$.type === 'export'; else confirmBlock">{{ "export" | translate }}</span> 
        <ng-template #confirmBlock>{{ "import" | translate }}</ng-template>
      </button>
    </div>
  </div>
</ng-container>